<button
  mat-icon-button
  class="bell-button"
  [matMenuTriggerFor]="bellMenu"
  #trigger="matMenuTrigger"
  (menuOpened)="onOpen()"
  [attr.aria-label]="unreadCount() ? 'Notifications, ' + unreadCount() + ' unread' : 'Notifications'"
>
  <mat-icon
    aria-hidden="false"
    [matBadge]="unreadCount() > 99 ? '99+' : unreadCount()"
    [matBadgeHidden]="unreadCount() === 0"
    matBadgeColor="warn"
    >notifications_none</mat-icon
  >
</button>

<mat-menu #bellMenu="matMenu" xPosition="before" class="notification-menu">
  <div class="notification-menu-header" (click)="$event.stopPropagation()">
    <strong>Notifications</strong>
    @if (unreadCount() > 0) {
      <span class="unread-pill">{{ unreadCount() }} unread</span>
    }
  </div>

  @if (loading() && items().length === 0) {
    <div class="notification-empty" (click)="$event.stopPropagation()">Loading…</div>
  } @else if (loadFailed()) {
    <div class="notification-empty" (click)="$event.stopPropagation()">
      <mat-icon aria-hidden="true">error_outline</mat-icon>
      <span>Could not load notifications. Please try again.</span>
    </div>
  } @else if (items().length === 0) {
    <div class="notification-empty" (click)="$event.stopPropagation()">
      <mat-icon aria-hidden="true">notifications_off</mat-icon>
      <span>No notifications available</span>
    </div>
  } @else {
    <div class="notification-list">
      @for (item of items(); track item.id) {
        <button type="button" class="notification-item" (click)="open(item); trigger.closeMenu()">
          <span class="item-head">
            <span class="item-title">{{ item.title || item.trackingNo }}</span>
            <span class="item-time">{{ item.createdDate | date: 'd MMM, h:mm a' }}</span>
          </span>
          <span class="item-message">{{ item.message }}</span>
        </button>
      }
    </div>
  }

  <div class="notification-menu-footer">
    <a mat-flat-button routerLink="/notifications" class="view-all-button" (click)="trigger.closeMenu()">View All Notifications</a>
  </div>
</mat-menu>
